export default "__VITE_ASSET__E08bWhKJ__"